/* v8 ignore start */
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface IViewState {
  isMobile: boolean;
}

const initialState: IViewState = {
  isMobile: false,
};

const viewSlice = createSlice({
  name: "view",
  initialState,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
  },
});

export const isMobileSelector = (state: {view: IViewState}) => state.view.isMobile;

export const {setIsMobile} = viewSlice.actions;
export default viewSlice.reducer;
/* v8 ignore stop */
